/**
 * Decimalni sati (Firestore) ↔ prikaz u satima i minutama.
 * Koristi ukupne minute (zaokruženo) da se izbjegne greška float tipa:
 * npr. 2h 47min spremljeno kao 2.78333… pri prikazu ne padne na 2h 46min.
 */

/**
 * Iz decimalnih sati u { hours, minutes } za prikaz / polja u modalu.
 */
export function partsFromDecimalHours(decimal) {
  if (decimal == null || isNaN(decimal) || decimal <= 0) {
    return { hours: 0, minutes: 0 };
  }
  const totalMinutes = Math.round(Number(decimal) * 60);
  return {
    hours: Math.floor(totalMinutes / 60),
    minutes: totalMinutes % 60,
  };
}

/**
 * Pozitivna trajanja (Glovo/Wolt po danu) → "2h 47min"
 */
export function formatDecimalHoursDisplay(decimalHours) {
  const { hours, minutes } = partsFromDecimalHours(decimalHours);
  if (hours === 0 && minutes === 0) return '0h';
  return minutes > 0 ? `${hours}h ${minutes}min` : `${hours}h`;
}

/**
 * Može biti negativno (npr. preostalo sati u tjednu).
 */
export function formatDecimalHoursSigned(decimalHours) {
  if (decimalHours == null || isNaN(decimalHours)) return '0h';
  if (decimalHours === 0) return '0h';
  const sign = decimalHours < 0 ? '-' : '';
  const abs = Math.abs(Number(decimalHours));
  const totalMinutes = Math.round(abs * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h === 0 && m === 0) return '0h';
  return m > 0 ? `${sign}${h}h ${m}min` : `${sign}${h}h`;
}
